import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../core/context/ToolContext";
import { CstmTextField } from "../../../../core/global/forms/CstmTextField";
import { Sync as SyncIcon } from "@mui/icons-material";
import { Grid, Button, Box } from "@mui/material";
import moment from "moment";
import { CstmSnackBar } from "../../../../core/global/forms/CstmSnackBar";
import ReceiptIcon from '@mui/icons-material/Receipt';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

export const Generate = ({ handleGenerate }) => {
    const today = moment().format("YYYY-MM-DD");
    const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
    const { reconciliation_state, tool_state } = useContext(ToolContext);
    const { date, isToReconcile, dateForm, snackBarLoader } = reconciliation_state;
    const { __SESSION } = tool_state;
    const role = __SESSION.data.uaccess[0].role_name;

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "date") { date.set(value); }
        if (name === "dateFrom") { dateForm.set(prev => ({ ...prev, date_from: value })); }
        if (name === "dateTo") { dateForm.set(prev => ({ ...prev, date_to: value })); }
    };

    useEffect(() => {
        if (!date.data) { date.set(today); }
        if (!dateForm.data?.date_from || !dateForm.data?.date_to) {
            dateForm.set(prev => ({ ...prev, date_from: today, date_to: today }));
        }
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {role === 'Supervisor' || role === 'Accounting' ?
                <Box display="flex" alignItems="center" gap={1} mt={6} mb={2}>
                    <Box flex={1} px={2} py={0.5} textAlign="center" borderRadius={2} sx={{ cursor: 'pointer', bgcolor: "grey.300", color: "text.primary", fontWeight: 600, fontSize: 14, lineHeight: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        <TaskAltIcon fontSize="small" /> Reconciliation Reports
                    </Box>
                </Box>
                :
                <Box display="flex" alignItems="center" gap={1} mt={6} mb={2}>
                    <Box flex={1} px={2} py={0.5} textAlign="center" borderRadius={2} onClick={() => isToReconcile.set(true)} sx={{ cursor: 'pointer', bgcolor: isToReconcile.data ? "primary.main" : "grey.300", color: isToReconcile.data ? "#fff" : "text.primary", fontWeight: 600, fontSize: 14, lineHeight: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        <ReceiptIcon fontSize="small" /> To Reconcile
                    </Box>
                    <Box flex={1} px={2} py={0.5} textAlign="center" borderRadius={2} onClick={() => isToReconcile.set(false)} sx={{ cursor: 'pointer', bgcolor: !isToReconcile.data ? "primary.main" : "grey.300", color: !isToReconcile.data ? "#fff" : "text.primary", fontWeight: 600, fontSize: 14, lineHeight: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                        <TaskAltIcon fontSize="small" /> Reconciled
                    </Box>
                </Box>
            }

            {isToReconcile.data && role === "Regular User" ? (
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={8}>
                        <CstmTextField onInput={handleChange} value={date.data || ""} name="date" label="Date" type="date" fullWidth variant="outlined" size="small" InputProps={{ inputProps: { max: today || moment().format("YYYY-MM-DD") } }} InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={handleGenerate} fullWidth sx={{ height: 40, borderRadius: 2, bgcolor: 'primary.main', color: '#fff', fontWeight: 600, fontSize: 14, textTransform: 'none', ':hover': { bgcolor: 'primary.dark' } }} startIcon={<SyncIcon />}>Generate</Button>
                    </Grid>
                </Grid>
            ) : (
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={6} sm={4.5} lg={5}>
                        <CstmTextField onInput={handleChange} value={dateForm.data?.date_from || ""} name="dateFrom" label="Date from" type="date" fullWidth variant="outlined" size="small" InputProps={{ inputProps: { max: today || moment().format("YYYY-MM-DD"), min: role === "Regular User" ? yesterday : undefined } }} InputLabelProps={{ shrink: true }} error={!dateForm.data?.date_from} />
                    </Grid>
                    <Grid item xs={6} sm={4.5} lg={5}>
                        <CstmTextField onInput={handleChange} value={dateForm.data?.date_to || ""} name="dateTo" label="Date to" type="date" fullWidth variant="outlined" size="small" InputProps={{ inputProps: { min: dateForm.data?.date_from || undefined, max: today || moment().format("YYYY-MM-DD") } }} InputLabelProps={{ shrink: true }} error={!dateForm.data?.date_to || (dateForm.data?.date_from > dateForm.data?.date_to)} />
                    </Grid>
                    <Grid item xs={12} sm={3} lg={2}>
                        <Button onClick={handleGenerate} fullWidth sx={{ height: 40, borderRadius: 2, bgcolor: 'primary.main', color: '#fff', fontWeight: 600, fontSize: 14, textTransform: 'none', ':hover': { bgcolor: 'primary.dark' } }} startIcon={<SyncIcon />}>Generate</Button>
                    </Grid>
                </Grid>
            )}

            {snackBarLoader.data.snackbar && (
                <CstmSnackBar value={snackBarLoader.data} setter={snackBarLoader.set} msg={snackBarLoader.data.msg} type='error' />
            )}
        </>
    );
};
